import { Divider } from "@mui/material";
import Flex from "../../../../../components/Flex";
import { useFaxIncomingList } from "../../../../../queries/communication/fax-integration/use-fax-incoming-list";
import { useInfiniteScroll } from "../../../../../hooks/use-infinite-scroll";
import { DGT_Pagination, getXtenantId } from "../../../../../utils/utils";
import FaxSideSection from "./FaxSideSection";
import FaxHeader from "./FaxHeader";
import { useEffect, useState } from "react";
import { useGetFaxIncomingByUuidById } from "../../../../../queries/communication/fax-integration/use-get-fax-incoming-by-uuid";
import { useFaxMarkAsRead } from "../../../../../queries/communication/fax-integration/use-fax-mark-as-read";
import { useQueryClient } from "@tanstack/react-query";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import { FlexCenterWrapper } from "../../../../../components/DefaultNoDataWrapper";
import Text from "../../../../../components/Text";

const IncomingFax = () => {
  const [searchKey, setSearchKey] = useState("");
  const [activeTab, setActiveTab] = useState("all");
  const [selectedFax, setSelectedFax] = useState<any>(null);
  const [pagination, setPagination] = useState<DGT_Pagination>({
    page: 0,
    pageSize: 20,
  });
  const queryClient = useQueryClient();
  const {
    data: incomingFaxList,
    isLoading: isLoadingIncomingFaxList,
    isFetching: isFetchingIncomingFaxList,
  } = useFaxIncomingList({
    pagination,
    gridSorting: [],
    searchString: searchKey || undefined,
    read: activeTab === "all" ? undefined : false,
    xTENANTID: getXtenantId(),
  });

  const { items: faxItems, onScroll } = useInfiniteScroll<any>({
    pagination,
    setPagination,
    content: incomingFaxList?.data?.content,
    totalElements: incomingFaxList?.data?.page?.totalElements,
    isFetching: isFetchingIncomingFaxList,
    dedupeKey: "uuid",
  });

  const handleSearchChange = (v: string) => {
    setSearchKey(v);
    setPagination((p) => ({ ...p, page: 0 }));
  };
  const handleTabChange = (v: string) => {
    setActiveTab(v);
    setPagination((p) => ({ ...p, page: 0 }));
  };

  const { data: unreadFaxList } = useFaxIncomingList({
    pagination: { page: 0, pageSize: 1 },
    gridSorting: [],
    read: false,
    xTENANTID: getXtenantId(),
  });
  const unreadCount = unreadFaxList?.data?.page?.totalElements;

  const { data: allFaxList } = useFaxIncomingList({
    pagination: { page: 0, pageSize: 1 },
    gridSorting: [],
    xTENANTID: getXtenantId(),
  });
  const allCount = allFaxList?.data?.page?.totalElements;

  const { data: faxData, isLoading: isLoadingFaxData } =
    useGetFaxIncomingByUuidById({
      faxIncomingUuid: selectedFax?.uuid,
      enabled: !!selectedFax?.uuid,
    });
  const { mutate: markAsRead } = useFaxMarkAsRead();
  const handleMarkAsRead = () => {
    markAsRead(
      {
        faxUuid: selectedFax?.uuid,
        isRead: true,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ["fax-incoming-list"] });
        },
      }
    );
  };

  useEffect(() => {
    if (selectedFax && activeTab === "unread") {
      handleMarkAsRead();
    }
  }, [selectedFax]);

  return (
    <Flex height={"100%"} width={"100%"}>
      <LoadingOverlay
        isLoading={isLoadingIncomingFaxList || isLoadingFaxData}
      />
      <Divider sx={{ width: "1px", backgroundColor: "gray" }} />

      <Flex height={"100%"} width={"100%"} gap={1}>
        <FaxSideSection
          faxItems={faxItems}
          loading={isFetchingIncomingFaxList}
          onScroll={onScroll}
          unreadCount={unreadCount}
          allCount={allCount}
          searchKey={searchKey}
          activeTab={activeTab}
          setSearchKey={handleSearchChange}
          setActiveTab={handleTabChange}
          showTabs={true}
          selectedFax={selectedFax}
          setSelectedFax={setSelectedFax}
        />
        <Flex flex={1} p={1.2} height="100%">
          {selectedFax && (
            <FaxHeader faxData={faxData?.data} isIncomingFax={true} />
          )}
          {!selectedFax && (
            <FlexCenterWrapper>
              {" "}
              <Text> Please Select Fax to view in detail </Text>
            </FlexCenterWrapper>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default IncomingFax;
